import { fromPairs } from 'lodash';
import { IExpression } from '../IExpression';
import { IExpressionType } from '../IExpressionType';
import { AsyncExpressionType } from './async/AsyncExpression.type';
import { ConditionGroupExpressionType } from './condition-group/ConditionGroupExpression.type';
import { ConditionExpressionType } from './condition/ConditionExpression.type';
import { FunctionExpressionType } from './function/FunctionExpression.type';
import { ReferenceExpressionType } from './reference/ReferenceExpression.type';
import { SubconditionGroupExpressionType } from './subconditions-group/SubconditionsGroupExpression.type';
import { SwitchExpressionType } from './switch-expression/SwitchExpression.type';
import { ValueExpressionType } from './value/ValueExpression.type';

const ExpressionTypes: IExpressionType[] = [
  AsyncExpressionType,
  ConditionExpressionType,
  ConditionGroupExpressionType,
  FunctionExpressionType,
  ReferenceExpressionType,
  SubconditionGroupExpressionType,
  ValueExpressionType,
  SwitchExpressionType,
];

export const ExpressionRepository = {
  mappedTypes: fromPairs(ExpressionTypes.map(type => [type.type, type])),
  get<TExpr extends IExpression>(type: TExpr['type']): IExpressionType<TExpr> {
    return this.mappedTypes[type] as unknown as IExpressionType<TExpr>;
  },
};
